export default __webpack_public_path__ + "static/media/delete_black_24dp.e8374a42.svg";